// Settings navigation logic — framework-agnostic, zero React imports

import type { SettingsNavGroup } from './types';

/** Settings sidebar navigation groups */
export const SETTINGS_NAV_GROUPS: SettingsNavGroup[] = [
  {
    id: 'account',
    labelKey: 'settings.nav.account',
    items: [
      { id: 'profile', labelKey: 'settings.nav.profile', href: '/settings/profile', icon: 'user', descriptionKey: 'settings.nav.profileDesc' },
      { id: 'contacts', labelKey: 'settings.nav.contacts', href: '/settings/contacts', icon: 'contact', descriptionKey: 'settings.nav.contactsDesc' },
      { id: 'preferences', labelKey: 'settings.nav.preferences', href: '/settings/preferences', icon: 'sliders', descriptionKey: 'settings.nav.preferencesDesc' },
      { id: 'invitations', labelKey: 'settings.nav.invitations', href: '/settings/invitations', icon: 'mail', descriptionKey: 'settings.nav.invitationsDesc' },
    ],
  },
  {
    id: 'security',
    labelKey: 'settings.nav.security',
    items: [
      { id: 'security', labelKey: 'settings.nav.securitySettings', href: '/settings/security', icon: 'shield', descriptionKey: 'settings.nav.securityDesc' },
      { id: 'sessions', labelKey: 'settings.nav.sessions', href: '/settings/sessions', icon: 'monitor', descriptionKey: 'settings.nav.sessionsDesc' },
      { id: 'consents', labelKey: 'settings.nav.consents', href: '/settings/consents', icon: 'key', descriptionKey: 'settings.nav.consentsDesc' },
      { id: 'api-keys', labelKey: 'settings.nav.apiKeys', href: '/settings/api-keys', icon: 'key', descriptionKey: 'settings.nav.apiKeysDesc' },
    ],
  },
  {
    id: 'integrations',
    labelKey: 'settings.nav.integrations',
    items: [
      { id: 'webhooks', labelKey: 'settings.nav.webhooks', href: '/settings/webhooks', icon: 'webhook', descriptionKey: 'settings.nav.webhooksDesc' },
    ],
  },
];

/** All settings nav items flat */
export const SETTINGS_NAV_ITEMS = SETTINGS_NAV_GROUPS.flatMap((g) => g.items);

/** Check if a path matches the settings nav item */
export function isSettingsNavActive(currentPath: string, href: string): boolean {
  return currentPath === href || currentPath.startsWith(href + '/');
}

/** Get the current settings section title key from path */
export function getSettingsTitleKey(currentPath: string): string {
  const item = SETTINGS_NAV_ITEMS.find((i) => currentPath === i.href);
  return item?.labelKey ?? 'settings.nav.profile';
}
